module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/yoojo-direct-9eaf6b29f09532846115a4cb525a04e1.svg";